import { render, staticRenderFns } from "./dr-rating.vue?vue&type=template&id=76f9d06c&scoped=true&"
import script from "./dr-rating.vue?vue&type=script&lang=js&"
export * from "./dr-rating.vue?vue&type=script&lang=js&"
import style0 from "./dr-rating.vue?vue&type=style&index=0&id=76f9d06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f9d06c",
  null
  
)

export default component.exports